import autojamPhoto from "../assets/autojam_1.png";
import autotablesPhoto from "../assets/autotables_1.png";
import type { Step, ServiceType } from "../types";

const common_service_steps: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Готовая система управления. Всё для роста дохода без дополнительных настроек и сложностей.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value:
          "Вся информация в одном месте. Оперативно по каждому магазину, ничего не нужно собирать вручную.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value:
          "Экономия времени каждый день. Удобный интерфейс и быстрые отчёты — до 10 часов в неделю свободны для бизнеса.",
      },
    ],
  },
];

interface ServiceConfigData {
  title: string;
  photo: string;
  steps_1: Step[];
  steps_2: Step[];
  service_steps: Step[];
}

export const serviceConfig: Record<ServiceType, ServiceConfigData> = {
  auto_table: {
    title: "Автотаблицы",
    photo: autotablesPhoto,
    steps_1: [
      {
        index: 1,
        content: [
          { type: "Text", value: "Перейдите в шаблонную таблицу по ссылке:" },
          {
            type: "LinkField",
            value:
              "https://docs.google.com/spreadsheets/d/1MYgutp6YUOhz-yxj3aCq8LBrYCIIrq_GNUsgkNa1XS0/edit?gid=834469971#gid=83446-9971",
          },
        ],
      },
      {
        index: 2,
        content: [
          {
            type: "Text",
            value:
              "Файл / Создать копию / Придумайте название таблицы / Создать копию.",
          },
        ],
      },
      {
        index: 3,
        content: [
          {
            type: "Text",
            value:
              "В правом верхнем углу Настройки доступа / Вставьте эту строку:",
          },
          { type: "CopyField", flag: "email", value: "" },
        ],
      },
    ],
    steps_2: [
      {
        index: 4,
        content: [
          {
            type: "Text",
            value:
              "Нажмите Меню в вашей Google Таблице и выберите Включить таблицу. Согласитесь со всеми пунктами.",
          },
        ],
      },
      {
        index: 5,
        content: [
          {
            type: "Text",
            value:
              "Скопируйте ссылку из адресной строки браузера и вставьте ее в поле ниже:",
          },
        ],
      },
    ],
    service_steps: common_service_steps,
  },
  auto_jam: {
    title: "Автоджем",
    photo: autojamPhoto,
    steps_1: [
      {
        index: 1,
        content: [
          { type: "Text", value: "Перейдите в шаблонную таблицу по ссылке:" },
          {
            type: "LinkField",
            value:
              "https://docs.google.com/spreadsheets/d/1h5jornLDuKFJzsLMj5HpXn59dlxMKKUscIr4qYS29UE",
          },
        ],
      },
      {
        index: 2,
        content: [
          {
            type: "Text",
            value:
              "Файл / Создать копию / Придумайте название таблицы / Создать копию.",
          },
        ],
      },
      {
        index: 3,
        content: [
          {
            type: "Text",
            value:
              "В правом верхнем углу Настройки доступа / Вставьте эту строку:",
          },
          { type: "CopyField", flag: "email", value: "" },
        ],
      },
    ],
    steps_2: [
      {
        index: 4,
        content: [
          {
            type: "Text",
            value:
              "Нажмите Меню в вашей Google Таблице и выберите Включить таблицу. Согласитесь со всеми пунктами.",
          },
        ],
      },
      {
        index: 5,
        content: [
          {
            type: "Text",
            value:
              "Скопируйте ссылку из адресной строки браузера и вставьте ее в поле ниже:",
          },
        ],
      },
    ],
    service_steps: common_service_steps,
  },
};
